import { jsx as _jsx } from 'react/jsx-runtime.js';
import { SocialsWrapper } from './index.js';
import { AppleButton } from '../../redux/features/loginWithApple/index.js';
import { GoogleButton } from '../../redux/features/google/GoogleButton/index.js';
import { FacebookButton } from '../../redux/features/facebook/FacebookButton/index.js';
import { LinkedInButton } from '../../redux/features/loginWithLinkedIn/index.js';
export const SocialButtonWithWrapper = ({ variant, buttonText, }) => {
    const buttons = {
        google: _jsx(GoogleButton, { buttonText: buttonText }, 'google'),
        apple: _jsx(AppleButton, { buttonText: buttonText }, 'apple'),
        linkedIn: _jsx(LinkedInButton, { buttonText: buttonText }, 'linkedIn'),
        facebook: _jsx(FacebookButton, { buttonText: buttonText }, 'facebook'),
    };
    return _jsx(SocialsWrapper, { children: buttons[variant] });
};
//# sourceMappingURL=SocialButtonWithWrapper.js.map